/* eslint-disable */

import { Autocomplete, Box, Button, Grid, Paper, TextField, Typography, IconButton, CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import axios from 'axios';
import { toast } from 'react-toastify';
import EditIcon from '@mui/icons-material/Edit';
import { useSelector } from 'react-redux';


import palette from 'src/theme/palette';
import { useResponsiveStyles } from 'src/utils/responsiveStyles';
import Key from '../../clientVariables.json';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.grey[600],
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function createData(itemid, itemName, itemDescription, itemType, unitOfMeasure) {
  return { itemid, itemName, itemDescription, itemType, unitOfMeasure };
}

const initialData = {
  itemid: '',
  itemName: '',
  itemDescription: '',
  itemType: 'Intangable',
  unitOfMeasure: '',
  // sizeOfUnit: '',
}

const Items = () => {
  const currentUser = useSelector((state) => state.UserReducer.user);
  const styles = useResponsiveStyles();
  const [strings, setStrings] = useState([]);
  const [formData, setFormData] = useState(initialData);
  const [rows, setRows] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [submitLoading, setSubmitLoading] = useState();

  useEffect(() => {
    addNewString();
    getItems();
  }, []);

  useEffect(() => {
    // const rowData = formData.map((item) =>
    // );
    // setRows([createData(
    //   formData.itemid,
    //   formData.itemName,
    //   formData.itemDescription,
    //   formData.itemType,
    //   formData.unitOfMeasure,
    // )]);
  }, [formData]);

  const addNewString = () => {
    const newString = generateUniqueString();
    setStrings([...strings, newString]);
    setFormData((prev) => ({
      ...prev,
      itemid: newString,
    }));
  };

  const handleChange = (feild, value) => {
    setFormData((prev) => ({
      ...prev,
      [feild]: value,
    }));
  };

  const SubmitOrUpdate = async() => {
    if(isEdit && formData.itemid){
      await updateItem(formData.itemid)
    }else{
      await SubmitHandle();
    }
  }

  const SubmitHandle = async () => {
    setSubmitLoading(true);
    try {
      const response = await axios.post(`${Key.domain}/payment/item/add`, {
        admin_id: currentUser?.id,
        name: formData?.itemName,
        description: formData?.itemDescription,
        type: formData?.itemType,
        uom: formData?.unitOfMeasure,
      });
      if (response.status === 200) {
        console.log(response);
        getItems();
        toast.success('Added Succefully', {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setSubmitLoading(false);
        setFormData(initialData);
      }
    } catch (error) {
      console.error(error);
      toast.error('Something went wrong try again!', {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setSubmitLoading(false);
    }
  };

  const getItems = async () => {
    try {
      const response = await axios.get(`${Key.domain}/payment/items`);
      if (response.status === 200) {
        console.log(response.data);
        const resData = response.data.data;
        const rowData = resData.map((item) => createData(item.item_id, item.name, item.description, item.type, item.uom));
        setRows(rowData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const editItemHandler = (data) => {
    console.log('editItem',data);
    setFormData((prev) => ({
      ...prev,
      itemid: data.itemid,
      itemName: data.itemName,
      itemDescription: data.itemDescription,
      itemType: data.itemType,
      unitOfMeasure: data.unitOfMeasure,
    }))
    setIsEdit(true);
    
  }

  const updateItem = async(id) => {
    setSubmitLoading(true);
    try {
      const response = await axios.put(`${Key.domain}/payment/item/${id}`, {
        admin_id: currentUser?.id,
        name: formData.itemName,
        description: formData.itemDescription,
        type: formData.itemType,
        uom: formData.unitOfMeasure,
      });
      if(response.status === 200){
        toast.success(`Succefully Updated Item (ID: ${id})`, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        getItems();
        setIsEdit(false);
        setSubmitLoading(false);
        setFormData(initialData);

      }
    } catch (error) {
      console.error(error);
      toast.error(`Failed to Update Item (ID: ${id})`, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setIsEdit(false);
        setSubmitLoading(false);
    }
  }

  function generateRandomString() {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < 6; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  }

  const generatedStrings = new Set();

  function generateUniqueString() {
    let newString;
    do {
      newString = generateRandomString();
    } while (generatedStrings.has(newString));
    generatedStrings.add(newString);
    return newString;
  }

  const types = ['Tangable', 'Intangable'];
  const unitOfMeasureList = ['Each Profile', 'Each User', 'Each Job', 'Each Support'];
  const itemNameList = ['Profile', 'User', 'Job', 'Support'];

  const boxListStyles = {
    display: 'flex',
    gap: '20px',
    p: '10px',
  };

  const text1Styles = {
    m: 0,
    // fontSize: styles.fontSize12,
    // fontWeight: 500,
    color: palette.grey[800],
    textTransform: 'capitalize',
  };

  const iconStyles = {
    fontSize: styles.icon20,
    color: palette.grey[500],
  };
  const listItemGridStyles = {
    borderBottom: `1px solid ${palette.grey[200]}`,
    p: '5px',
  };
  const listItemGridContainerStyles = {
    alignItems: 'center',
  };
  return (
    <Grid container spacing={0}>
      <Grid item xs={6}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'start',
            width: '100%',
            height: window.innerHeight - 100,
            bgcolor: '#F2F4FA',
            p: '10px',
          }}
        >
          <Paper elevation={2} sx={{ p: '10px' }}>
            <Typography variant="body1" sx={{ borderBottom: `1px solid ${palette.grey[700]}`, mb: '10px' }}>
              Add Item
            </Typography>
            <Grid container spacing={2}>
              {/* <Grid item xs={12} sx={listItemGridStyles}>
                <Grid container spacing={0} sx={listItemGridContainerStyles}>
                <Grid item xs={4}>
                    <Box sx={boxListStyles}>
                      <Typography variant='body2' sx={{ ...text1Styles }}>
                        Item ID
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={1}>:</Grid>
                  <Grid item xs={7} sx={{}}>
                    <TextField fullWidth
                      placeholder="Item Number" disabled
                      size="small"
                      value={formData.itemid}
                      onChange={(e) => handleChange('itemid', e.target.value)}
                      // error={Boolean(formErrors.itemid)}
                      // helperText={formErrors.itemid}
                      id="itemid"
                      autoComplete="off"
                      
                    />
                  </Grid>
                 
                </Grid>
              </Grid> */}
              <Grid item xs={12} sx={listItemGridStyles}>
                <Grid container spacing={0} sx={listItemGridContainerStyles}>
                  <Grid item xs={4}>
                    <Box sx={boxListStyles}>
                      <Typography variant="body2" sx={{ ...text1Styles }}>
                        Item Name
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={1}>
                    :
                  </Grid>
                  <Grid item xs={7} sx={{}}>
                    <Autocomplete
                      size="small"
                      disablePortal
                      fullWidth
                      options={itemNameList}
                      getOptionLabel={(option) => option}
                      value={formData.itemName !== '' ? formData.itemName : null}
                      onChange={(event, newValue) => handleChange('itemName', newValue)}
                      renderInput={(params) => <TextField {...params} placeholder="Item Name" />}
                      //   error={formErrors.itemName}
                      //   helperText={formErrors.itemName}
                      id="itemName"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sx={listItemGridStyles}>
                <Grid container spacing={0} sx={listItemGridContainerStyles}>
                  <Grid item xs={4}>
                    <Box sx={boxListStyles}>
                      <Typography variant="body2" sx={{ ...text1Styles }}>
                        Item Description
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={1}>
                    :
                  </Grid>
                  <Grid item xs={7} sx={{}}>
                    <TextField
                      fullWidth
                      placeholder="Item Description"
                      size="small"
                      value={formData.itemDescription}
                      onChange={(e) => handleChange('itemDescription', e.target.value)}
                      // error={Boolean(formErrors.itemDescription)}
                      // helperText={formErrors.itemDescription}
                      id="itemDescription"
                      autoComplete="off"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sx={listItemGridStyles}>
                <Grid container spacing={0} sx={listItemGridContainerStyles}>
                  <Grid item xs={4}>
                    <Box sx={boxListStyles}>
                      <Typography variant="body2" sx={{ ...text1Styles }}>
                        Item Type
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={1}>
                    :
                  </Grid>
                  <Grid item xs={7} sx={{}}>
                    <Autocomplete
                      size="small"
                      disablePortal
                      fullWidth
                      options={types}
                      getOptionLabel={(option) => option}
                      value={formData.itemType !== '' ? formData.itemType : null}
                      onChange={(event, newValue) => handleChange('itemType', newValue)}
                      renderInput={(params) => <TextField {...params} placeholder="Item Type" />}
                      //   error={formErrors.itemType}
                      //   helperText={formErrors.itemType}
                      id="itemType"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sx={listItemGridStyles}>
                <Grid container spacing={0} sx={listItemGridContainerStyles}>
                  <Grid item xs={4}>
                    <Box sx={boxListStyles}>
                      <Typography variant="body2" sx={{ ...text1Styles }}>
                        Unit Of Measure
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={1}>
                    :
                  </Grid>
                  <Grid item xs={7} sx={{}}>
                    <Autocomplete
                      size="small"
                      disablePortal
                      fullWidth
                      options={unitOfMeasureList}
                      getOptionLabel={(option) => option}
                      value={formData.unitOfMeasure !== '' ? formData.unitOfMeasure : null}
                      onChange={(event, newValue) => handleChange('unitOfMeasure', newValue)}
                      renderInput={(params) => <TextField {...params} placeholder="Unit Of Measure" />}
                      //   error={formErrors.unitOfMeasure}
                      //   helperText={formErrors.unitOfMeasure}
                      id="unitOfMeasure"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                  <Button variant="contained" onClick={SubmitOrUpdate}>
                    {submitLoading ? 
                    <CircularProgress size={20} color="inherit" />
                    :
                    (isEdit ? 'Save Changes' : 'Add Item')}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </Grid>
      <Grid item xs={6}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'start',
            width: '100%',
            height: window.innerHeight - 100,
            bgcolor: '#F2F4FA',
            p: '10px',
          }}
        >
          <TableContainer component={Paper} elevation={4}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell>Item ID</StyledTableCell>
                  <StyledTableCell align="left">Item Name </StyledTableCell>
                  <StyledTableCell align="left">Item Description </StyledTableCell>
                  <StyledTableCell align="left">Item Type</StyledTableCell>
                  <StyledTableCell align="left">UOM</StyledTableCell>
                  <StyledTableCell align="left">Actions</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {rows &&
                  rows?.map((row) => (
                    <StyledTableRow key={row.itemid} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                      <StyledTableCell component="th" scope="row">
                        {row.itemid}
                      </StyledTableCell>
                      <StyledTableCell align="left">{row.itemName}</StyledTableCell>
                      <StyledTableCell align="left">{row.itemDescription}</StyledTableCell>
                      <StyledTableCell align="left">{row.itemType}</StyledTableCell>
                      <StyledTableCell align="left">{row.unitOfMeasure}</StyledTableCell>
                      <StyledTableCell align="left">
                        <IconButton onClick={() => editItemHandler(row)}>
                        <EditIcon  />
                        </IconButton>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Items;
